import { Carousel, Row } from "antd";
import React from "react";
import PageContainer from "../layout/PageContainer";

import step1 from "../assets/images/registerMethod/carAddStep1.jpg";
import step2 from "../assets/images/registerMethod/carAddStep2.jpg";
import step3 from "../assets/images/registerMethod/carAddStep3.jpg";
import step4 from "../assets/images/registerMethod/carAddStep4.jpg";
import btnImage from "../assets/images/registerMethod/textQRbuttonImage.svg";
import styles from "./RegisterCarMethod.module.css";

const contentStyle: React.CSSProperties = {
    margin: 0,
    height: "160px",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#364d79",
};

function RegisterCarMethod() {
    return (
        <PageContainer pageBackground={"white"} contentPadding={16}>
            <Row align="middle" justify="center">
                <div style={{ textAlign: "center" }} className={`container`}>
                    <Carousel className={styles.carousel}>
                        <div style={contentStyle}>
                            <img src={step1} className={styles.image}></img>
                            <p className={styles.text}>1. 차량단말기 화면에 차량 번호를 눌러주세요.</p>
                            <img src={step2} className={styles.image}></img>
                            <p className={styles.text}>2. 차량 번호 입력 화면이 나오면 우측 상단에 QR코드 버튼을 눌러주세요.</p>
                        </div>
                        <div style={contentStyle}>
                            <img src={step3} className={styles.image}></img>
                            <p className={styles.text}>
                                3. QR코드 이미지를 띄운 후 스마트폰 &#34;차량 등록하기&#34; 화면에서
                                <img className={styles.btnImage} src={btnImage} height={28} width={100} />
                                버튼을 눌러 카메라 모드로 변경합니다.
                            </p>
                            <img src={step4} className={styles.image}></img>
                            <p className={styles.text}>4. 차량 단말기 QR코드를 스캔하면 차량번호와 시리얼 넘버가 등록됩니다.</p>
                        </div>
                    </Carousel>
                </div>
            </Row>
        </PageContainer>
    );
}

export default RegisterCarMethod;
